<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">值班值守&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>值守打卡</div>
        </div>
      </div>
    </div>
    <div class="section" v-if="!isDetail">
      <div class="left">
        <div class="title">打卡事项</div>
        <div class="search-box">
          <el-input
            placeholder="请输入内容"
            prefix-icon="el-icon-search"
            v-model="sxmc"
          >
          </el-input>
          <el-button
            v-if="!sqDeptName"
            style="
              width: 40px;
              height: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 12px;
            "
            @click="openIssuesDialogFun()"
            class="search el-icon-plus"
          ></el-button>
        </div>
        <div class="type-list">
          <div
            class="type-list-item"
            :class="{ active: sourceMangerId == item.id }"
            v-for="(item, index) in typeList"
            :key="index"
            @click="typeChange(item)"
          >
            <div class="item-top">
              <div class="name">{{ item.sxmc }}</div>
              <el-switch
                v-if="!sqDeptName"
                v-model="item.state"
                @change="
                  value => {
                    changeStateFun(value, item);
                  }
                "
                active-value="是"
                inactive-value="否"
                active-color="#0495FF"
              >
              </el-switch>
            </div>
            <div class="item-bottom">
              <div class="type">{{ item.extendClient }}</div>
              <div class="edit">
                <el-button
                  v-if="!sqDeptName"
                  @click="openIssuesDialogFun(item)"
                  icon="el-icon-edit"
                  type="text"
                  >编辑</el-button
                >
                <el-button
                  v-if="item.id != 'SHISHOU_LAJITONG' && !sqDeptName"
                  style="color: #eb3538"
                  @click="delEventEditFun(item)"
                  icon="el-icon-delete"
                  type="text"
                  >删除</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title">值守列表</div>
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="开始值守时间">
                  <el-date-picker
                    v-model="date"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                  >
                  </el-date-picker>
                </el-form-item>
                <!-- <el-form-item label="开始值守时间（止）">
                  <el-date-picker
                    v-model="form.logTimeEnd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择结束时间"
                    :clearable="false"
                  >
                  </el-date-picker>
                </el-form-item> -->
                <el-form-item label="值守人员姓名">
                  <el-input
                    v-model="form.username"
                    clearable
                    placeholder="请输入值守人员姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="table-top-btns">
            <div class="left-btn"></div>
            <div class="right-btn">
              <el-button v-if="!sqDeptName" @click="ruleDialogVisible = true" class="search"
                >配置值守规则</el-button
              >
              <el-button
                class="other el-icon-download"
                @click="userLocationLineExpFun"
                >导出打卡记录</el-button
              >
              <el-button
                class="other el-icon-download"
                @click="userLocationLineExpFun2"
                >导出列表</el-button
              >
            </div>
          </div>
          <common-table
            :maxHeight="640"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          >
            <template v-slot:operation="{ scope }">
              <el-button
                @click="detailFun(scope.row)"
                style="color: #0090ff; font-size: 16px"
                type="text"
                >详情</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <detail @clickBackList="isDetail = false" :curItem="curItem" v-else></detail>
    <ruleSettingDialog
      v-if="ruleDialogVisible"
      @refreshList="selListFun"
      :dialogVisible.sync="ruleDialogVisible"
      :curItem="curTypeItem"
    >
    </ruleSettingDialog>
    <issuesDialog
      v-if="issuesDialogVisible"
      @refreshList="selListFun"
      :dialogVisible.sync="issuesDialogVisible"
      :curItem="issuesCurItem"
    >
    </issuesDialog>
    <dakaDialog
      v-if="isdakaDialog"
      :dialogVisible.sync="isdakaDialog"
      :sourceMangerId="sourceMangerId"
    ></dakaDialog>
    <dakaDialog2
      v-if="isdakaDialog2"
      :dialogVisible.sync="isdakaDialog2"
      :sourceMangerId="sourceMangerId"
    ></dakaDialog2>
  </div>
</template>
<script>
import { eventPage, delEventEdit } from "@/api/base.js";
import {
  dutyLogjoinPage,
  mySqDept,
  changeState
} from "@/api/onDutyAndStandBy.js";
import commonTable from "@/components/table/index.vue";
import ruleSettingDialog from "./components/ruleSettingDialog.vue";
import issuesDialog from "./components/issuesDialog.vue";
import detail from "@/pages/onDuty/detail";
import dakaDialog from './components/dakaDialog.vue';
import dakaDialog2 from './components/dakaDialog2.vue';
export default {
  components: {
    commonTable,
    ruleSettingDialog,
    issuesDialog,
    detail,
    dakaDialog,
    dakaDialog2
  },
  data() {
    return {
      date: [],
      isdakaDialog:false,
      isdakaDialog2:false,
      curTypeItem: {},
      sxmc: "",
      form: {
        logTimeStart: "",
        logTimeEnd: "",
        username: ""  
      },
      ruleDialogVisible: false,
      issuesDialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "username",
            label: "值守人员姓名"
          },
          {
            prop: "startInPointName",
            label: "社区"
          }
        ]
      },
      issuesCurItem: {},
      typeList: [],
      sourceMangerId: null,
      isDetail: false,
      curItem: {},
      sqDeptName: null
    };
  },
  async mounted() {
    await this.getMySqDept();
    await this.selListFun();
  },
  methods: {
    async getMySqDept () {
      let res = await mySqDept()
      if (res.data.code == 200 && res.data.data) this.sqDeptName = res.data.data.deptName || null;
    },
    detailFun(item) {
      this.isDetail = true;
      this.curItem = item;
    },
    //删除单条事项目录类型
    delEventEditFun(item) {
      this.$confirm("是否删除该数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await delEventEdit({
            id: item.id
          });
          if (res.data.code == 200) {
            this.selListFun();
          } else {
            this.$message.warning(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //关闭
    async changeStateFun(value, item) {
      const res = await changeState({
        id: item.id,
        state: value
      });
      if (res.data.code == 200) {
        this.selListFun();
      } else {
        this.$message.warning(res.data.msg);
      }
    },
    typeChange(item) {
      this.sourceMangerId = item.id;
      this.curTypeItem = item;
      this.dataList.columns = [
        {
          prop: "username",
          label: "值守人员姓名"
        },
        {
          prop: "startInPointName",
          label: "社区"
        }
      ];
      if (item.id == "SHISHOU_LAJITONG") {
        this.dataList.columns.push({
          prop: "pointName",
          label: "垃圾桶站"
        });
      } else {
        this.dataList.columns.push({
          prop: "pointName",
          label: "打卡事项"
        });
      }
      if (item.extendCardCount == 2) {
        this.dataList.columns.push({
          prop: "logTime",
          label: "开始值守时间",
          // width: 160
        });
        this.dataList.columns.push({
          prop: "endLogTime",
          label: "结束值守时间",
          // width: 160
        });
        this.dataList.columns.push({
          prop: "computeHour",
          label: "值守时长"
        });
      } else {
        this.dataList.columns.push({
          prop: "logTime",
          label: "值守时间",
          // width: 160
        });
      }
      this.dataList.columns.push({
        slot: "operation",
        label: "操作",
        showToolitip: "1",
        width: 140
      });
      this.eventPageFun();
    },
    openIssuesDialogFun(item) {
      this.issuesDialogVisible = true;
      this.issuesCurItem = {
        editType: item ? "edit" : "add",
        ...item
      };
      if (!item) {
        this.issuesCurItem.id = "";
      }
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.eventPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.eventPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    onReset() {
      this.date = [];
      // this.form.logTimeStart = "";
      // this.form.logTimeEnd = "";
      this.form.username = "";
      this.page.page = 1;
      this.page.size = 10;
      this.eventPageFun();
    },
    async selListFun(sxmc) {
      let userinfo = JSON.parse(sessionStorage.getItem("userInfo"));
      let params = {
        sxmc,
        ghEventTypeId: "id_zhishou",
        page: 1,
        size: 99999,
        typeSource: "事项管理",
        tjDeptId: userinfo.deptId
      }
      if (!!this.sqDeptName) {
        params.zsSqUseFlag = 1;
        delete params.tjDeptId
      }
      if (userinfo.roles.map(item => item.roleCode).includes('GLLD')) delete params.tjDeptId;
      const res = await eventPage(params);
      this.typeList = res.data.data.records || [];
      if (this.typeList.length > 0) {
        if (this.sourceMangerId) {
          this.typeChange(
            res.data.data.records.find(item => item.id == this.sourceMangerId)
          );
        } else {
          this.typeChange(this.typeList[0]);
        }
      } else {
        this.dataList.tableData = [];
        this.page.total = 0;
      }
    },
    // 列表导出
    async userLocationLineExpFun2 () {
      this.isdakaDialog2 = true;
    },
    async userLocationLineExpFun() {
      this.isdakaDialog = true;
      // this.exportLoading = true;
      // let res = await dutyLogExp({
      //   logTimeStart: this.form.logTimeStart,
      //   logTimeEnd: this.form.logTimeEnd,
      //   username: this.form.username,
      //   ghEventTypeId: "id_zhishou",
      //   typeSource: "事项管理",
      //   sourceMangerId: this.sourceMangerId
      // });
      // if (res.status == 200) {
      //   this.exportLoading = false;
      //   const url = window.URL.createObjectURL(new Blob([res.data]));
      //   const link = document.createElement("a");
      //   link.href = url;
      //   link.setAttribute(
      //     "download",
      //     "值守记录" + new Date().getTime() + ".xlsx"
      //   );
      //   document.body.appendChild(link);
      //   link.click();
      // }
    },

    // 分页查询
    async eventPageFun() {
      let params = {
        logTimeStart: this.date && this.date.length ? this.date[0] : '',
        logTimeEnd: this.date && this.date.length ? `${this.date[1]} 23:59:59` : '',
        username: this.form.username,
        ghEventTypeId: "id_zhishou",
        page: this.page.page,
        size: this.page.size,
        typeSource: "事项管理",
        sourceMangerId: this.sourceMangerId
      };
      if (!!this.sqDeptName) params.inPointName = this.sqDeptName;
      const res = await dutyLogjoinPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  },
  watch: {
    sxmc: {
      deep: true,
      handler(sxmc) {
        this.selListFun(sxmc);
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.box-father {
  padding-bottom: 24px;

  .section {
    display: flex;
    padding: 0;

    .left {
      width: 20%;
      height: 100%;
      overflow: auto;
      padding: 28px 24px;
      border-right: 1px solid #e0e0e0;
    }

    .right {
      width: 80%;
      height: 100%;
      padding: 28px 24px;
    }

    .title {
      font-family: MiSans, MiSans;
      font-weight: 700;
      font-size: 20px;
      color: #494c4f;
      margin-bottom: 12px;
    }
  }
}

.search-box {
  display: flex;
  margin-bottom: 12px;
}

.type-list {
  height: 740px;
  overflow: auto;

  .type-list-item {
    width: 100%;
    // height: 94px;
    padding: 12px;
    background: #f7faff;
    border-radius: 4px;
    margin-bottom: 12px;
    cursor: pointer;

    .item-top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 18px;
        color: #494c4f;
        margin: 0 8px 6px 0;
      }
    }

    .item-bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .type {
        background: rgba(0, 144, 255, 0.1);
        border-radius: 2px;
        padding: 1px 6px;
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 16px;
        color: #0090ff;
        margin: 0 0 6px 0;
      }
      .edit {
        width: 140px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }

  .type-list-item.active {
    border: 1px solid #3caaff;
    background: #f7faff url("~@/assets/image/active.png") center no-repeat;
    background-size: 100% 100%;
    border-radius: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/standBy/index.vue